module.exports = __webpack_public_path__ + "public/images/afterschool-activities.0d8b9bd09a6ecb49fadcac52917d4ed5.png";